import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'

const WhyChoose = ({ data }) => {


    const navigate = useNavigate()

    return (
        <div className='max-w-screen-2xl mx-auto py-5 md:py-8 w-[87%] md:w-full md:px-12'>
            <h1
                className='text-xl dark:text-white md:text-2xl font-bold text-center'
            >
                <span className='text-yellow-500'>Why should</span> you Choose <span className='text-red-500'>{data.title}?</span>
            </h1>
            <p className='text-center text-[15px] my-2 mx-auto md:max-w-[700px] dark:text-white'>
                {data.desc}
            </p>

            <div className='grid grid-cols-1 lg:grid-cols-3 my-5 lg:my-16  gap-4'>

                <div className='space-y-4 lg:space-y-6'>
                    {data.cards.map((item, i) => (
                        <div key={i}>
                            {i < 3 && (
                                <div className='bg-[#f2f7fb] px-3 py-5 rounded-lg hover:scale-95 duration-700'>
                                    <h1 className='font-bold text-[17px] sm:text-sm text-yellow-600'>
                                        {item.title}
                                    </h1>
                                    <p className='text-[14px] sm:text-xs mt-1'>
                                        {item.desc}
                                    </p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                <div>

                    <motion.img
                        whileInView={{ scale: [0.5, 1] }}
                        transition={{ duration: 0.8, ease: 'easeInOut' }}
                        src={data.img}
                        initial='hidden'
                        alt='img'
                        onClick={() => navigate('/pricing')}
                        className='w-[80%] lg:w-[90%] h-[300px] sm:h-[400px] lg:h-full mx-auto lg:object-contain cursor-pointer'
                    >
                    </motion.img>
                </div>

                <div className='flex flex-col gap-4 lg:gap-6'>
                    {data.cards.map((item, i) => (
                        <>
                            {i > 2 && (
                                <div key={i} className='bg-[#f2f7fb] px-3 py-5 rounded-lg hover:scale-95 duration-700'>
                                    <h1 className='font-bold text-[17px] sm:text-sm text-blue-500'>
                                        {item.title}
                                    </h1>
                                    <p className='text-[14px] sm:text-xs mt-1'>
                                        {item.desc}
                                    </p>
                                </div>
                            )}
                        </>
                    ))}
                </div>

            </div>
        </div>
    )
}

export default WhyChoose